/**
 * seoPages.js — PEFEP TECH
 * Source unique de verite pour les metadonnees SEO de chaque page.
 *
 * REGLES :
 *  - titre       : 50 a 60 caracteres
 *  - description : 140 a 160 caracteres
 *  - un seul H1 par page, distinct du <title>
 */

const SITE_URL = 'https://pefep.site';

/* ============ BLOC ORGANISATION (reutilise partout) ============ */
export const ORGANISATION = {
  '@type': 'Organization',
  '@id': SITE_URL + '/#organisation',
  legalName: 'PEFEP TECH',
  url: SITE_URL,
  logo: {
    '@type': 'ImageObject',
    url: SITE_URL + '/logo512.png',
    width: 512,
    height: 512,
  },
  image: SITE_URL + '/og-image.png',
  description:
    "PEFEP Site permet aux entrepreneurs et organisations de creer un site web professionnel en quelques minutes, sans competences techniques.",
  email: 'contact@pefep.site',


  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rue Georges Kernizan',
    addressLocality: 'Leogane',
    addressCountry: 'HT',
  },
  areaServed: {
    '@type': 'Country',
    name: 'Haiti',
  },
  // A COMPLETER : URLs de vos profils Facebook, LinkedIn, Instagram.
  sameAs: [],
};

/* ==================== METADONNEES PAR PAGE ==================== */
export const SEO_PAGES = {
  /* --------------------------- ACCUEIL --------------------------- */
  accueil: {
    chemin: '/',
    titre: 'Creer un site web professionnel en Haiti | PEFEP Site',
    description:
      "Creez votre site web professionnel en quelques minutes, sans competences techniques. Eglise, restaurant, ONG, boutique : 11 secteurs couverts.",
    indexable: true,
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        ORGANISATION,
        {
          '@type': 'WebSite',
          '@id': SITE_URL + '/#site',
          url: SITE_URL,
          name: 'PEFEP Site',
          inLanguage: 'fr',
          publisher: { '@id': SITE_URL + '/#organisation' },
        },
        {
          '@type': 'SoftwareApplication',
          name: 'PEFEP Site',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          inLanguage: 'fr',
          url: SITE_URL,
          publisher: { '@id': SITE_URL + '/#organisation' },
          description:
            "Generateur de sites web assiste par intelligence artificielle, concu pour les entrepreneurs et organisations francophones.",
          offers: {
            '@type': 'Offer',
            price: '49',
            priceCurrency: 'USD',
            availability: 'https://schema.org/InStock',
          },
          featureList: [
            'Generation de site web par intelligence artificielle',
            'Aucune competence technique requise',
            '11 secteurs d activite couverts',
            'Site pret en quelques minutes',
            'Essai gratuit avant paiement',
          ],
        },
      ],
    },
  },

  /* ---------------------------- TARIFS --------------------------- */
  tarifs: {
    chemin: '/tarifs',
    titre: 'Tarifs — Site web professionnel des 49$ | PEFEP Site',
    description:
      "Tarifs clairs et sans surprise : site web des 49$ pour les entrepreneurs, forfaits developpeurs et agences. Essayez gratuitement avant de payer.",
    indexable: true,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Site web professionnel PEFEP Site',
      description:
        "Creation d un site web professionnel assistee par intelligence artificielle, pour entrepreneurs, organisations et developpeurs.",
      brand: { '@id': SITE_URL + '/#organisation' },
      image: SITE_URL + '/og-image.png',
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'USD',
        lowPrice: '35',
        highPrice: '250',
        offerCount: '4',
        availability: 'https://schema.org/InStock',
      },
    },
  },

  /* ------------------------------ FAQ ---------------------------- */
  faq: {
    chemin: '/faq',
    titre: 'Questions frequentes | PEFEP Site',
    description:
      "Delais, tarifs, hebergement, nom de domaine, moyens de paiement : toutes les reponses sur la creation de votre site web avec PEFEP Site.",
    indexable: true,
    // IMPORTANT : chaque question/reponse doit apparaitre MOT POUR MOT
    // sur la page visible, sinon Google ignore ou sanctionne le balisage.
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Combien de temps faut-il pour creer mon site ?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'REMPLACER PAR LA REPONSE EXACTE AFFICHEE SUR LA PAGE FAQ.',
          },
        },
        {
          '@type': 'Question',
          name: 'Ai-je besoin de competences techniques ?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'REMPLACER PAR LA REPONSE EXACTE AFFICHEE SUR LA PAGE FAQ.',
          },
        },
        {
          '@type': 'Question',
          name: 'Quels moyens de paiement acceptez-vous ?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'REMPLACER PAR LA REPONSE EXACTE AFFICHEE SUR LA PAGE FAQ.',
          },
        },
      ],
    },
  },

  /* ----------------------- QUI SOMMES-NOUS ----------------------- */
  quiSommesNous: {
    chemin: '/qui-sommes-nous',
    titre: 'Qui sommes-nous — PEFEP Site, Un produit de PEFEP TECH',
    description:
      "PEFEP Site est un Produit de PEFEP TECH,la filiale technologique de PEFEP GROUPE, agence digitale basee a Leogane. Notre mission : rendre le web accessible a tous.",
    indexable: true,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'AboutPage',
      name: 'Qui sommes-nous',
      url: SITE_URL + '/qui-sommes-nous',
      mainEntity: { '@id': SITE_URL + '/#organisation' },
    },
  },

  /* ---------------------------- CONTACT -------------------------- */
  contact: {
    chemin: '/contact',
    titre: 'Nous contacter — PEFEP Site, Leogane Haiti',
    description:
      "Une question sur votre projet de site web ? Contactez l equipe PEFEP Site par WhatsApp ou par e-mail. Nous repondons sous 24 heures.",
    indexable: true,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'Contact',
      url: SITE_URL + '/contact',
      mainEntity: { '@id': SITE_URL + '/#organisation' },
    },
  },

  domaines: {
    chemin: '/domaines',
    titre: 'Nom de domaine en Haiti — tarifs reels | PEFEP Site',
    description:
      "Verifiez la disponibilite de votre nom de domaine et decouvrez nos tarifs reels : prix de la premiere annee et du renouvellement affiches sans frais caches.",
    indexable: true,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Enregistrement de nom de domaine',
      provider: { '@id': SITE_URL + '/#organisation' },
      areaServed: { '@type': 'Country', name: 'Haiti' },
      url: SITE_URL + '/domaines',
    },
  },
  /* ------------------ PAGES TECHNIQUES : NOINDEX ----------------- */
  connexion: {
    chemin: '/connexion',
    titre: 'Connexion | PEFEP Site',
    description: 'Accedez a votre espace personnel PEFEP Site.',
    indexable: false,
  },

  inscription: {
    chemin: '/inscription',
    titre: 'Creer un compte | PEFEP Site',
    description: 'Creez votre compte PEFEP Site et lancez votre premier site.',
    indexable: false,
  },

  /* -------------- ESPACES PRIVES : NOINDEX + Disallow ------------ */
  tableauDeBord: {
    chemin: '/tableau-de-bord',
    titre: 'Mon tableau de bord | PEFEP Site',
    description: 'Espace personnel PEFEP Site.',
    indexable: false,
  },

  creerMonSite: {
    chemin: '/creer-mon-site',
    titre: 'Creer mon site | PEFEP Site',
    description: 'Assistant de creation de site PEFEP Site.',
    indexable: false,
  },

  developpeur: {
    chemin: '/developpeur',
    titre: 'Espace developpeur | PEFEP Site',
    description: 'Espace developpeur PEFEP Site.',
    indexable: false,
  },

  admin: {
    chemin: '/admin',
    titre: 'Administration | PEFEP Site',
    description: 'Espace administration.',
    indexable: false,
  },
};

export default SEO_PAGES;